import React, {useState, useEffect} from "react";
import styled from "styled-components";
import db from "../../firebase";
import {collection, onSnapshot, orderBy, query, doc, writeBatch} from "firebase/firestore";
import {updateBillImageDelete} from "../../Backend/updateOperations"
import ClearIcon from "@mui/icons-material/Clear";
import Viewmore from "../Viewmore";

import {useDispatch} from "react-redux";
import {useSelector} from "react-redux";
import {selectType} from "../../features/modalSlice";

import Modal from "../Modal";
import PopupForm from "../PopupForm";
import EditFormModal from "../EditFormModal";
import DeleteModal from "../DeleteModal";
import ExcelExport from "../ExcelExport";
import BillTable from "./BillTable";
import BillFilters from "./BillFilter";
import {Button} from "@mui/material";
import {isSuperAdmin} from "../../constants/helpers";
import { de, is } from "date-fns/locale";

const Bills = () => {
  const modalType = useSelector(selectType);

  const isUserSuperAdmin = isSuperAdmin();

  const [operation, setOperation] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [modal, setModal] = useState("close");
  const [editDetails, setEditDetails] = useState([]);
  const [details, setDetails] = useState("");

  const [selectMode, setSelectMode] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [isEditPopupOpen, setEditPopupOpen] = useState(false);
  const [isFiltered, setIsFiltered] = useState(false);

  const [openDeleteBillImgModal, setDeleteBillImgModal] = useState(false);
  const [billImgToDelete, setBillImgToDelete] = useState("")

  const [zoom, setZoom] = useState("");
  const [mediaDataType, setMediaDataType] = useState("");

  const dispatch = useDispatch();

  const handleUpload = async (selectedIds, status, fileUrl) => {
    console.log(selectedIds, status, fileUrl);

    if (selectedIds.length === 0 || !fileUrl || !status) return(alert("Please select at least one entry, upload a file, and choose a status."));

    try {
      const batch = writeBatch(db); // assuming firebase v9+
      selectedIds.forEach(id => {
        const docRef = doc(db, "FormData", id);
        batch.update(docRef, {
          billStatus: status,
          billImage: fileUrl,
        });
      });
      await batch.commit();

      alert("Bills updated successfully!");
      setSelectedIds([]); // ✅ clear after upload
      setSelectMode(false); // optionally exit select mode
      setEditPopupOpen(false); // close edit popup if open
      setPopupOpen(false); // close popup
    } catch (err) {
      console.error("Upload error:", err);
    }
  };

  const getData = async () => {
    const formRef = query(
        collection(db, "FormData"),
        orderBy("deliveryTime", "desc"),
    );

    try {
      await onSnapshot(formRef, (querySnapshot) => {
        const data = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setOperation(data);
        setFilteredData(data);
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    const handlerESC = (event) => {
      const code = event.code;
      if (code === "Escape") {
        setModal("close");
        setDetails("");
      }
    };
    document.addEventListener("keydown", handlerESC);

    return () => {
      document.removeEventListener("keydown", handlerESC);
    };
  }, []);

  const handlerDetails = (id) => {
    switch (modal) {
      case "open":
        setDetails("");
        setModal("close");
        break;
      case "close":
        setDetails(id);
        setModal("open");
        break;
      default:
        setModal("close");
    }
  };

  const closeDeleteBillImgModal = () => {
        setBillImgToDelete("") //Clear state
        setDeleteBillImgModal(false); //Close Modal
  }

  const handlerDeleteBillImg = (id) => {
        setBillImgToDelete(id) //Set state
        setDeleteBillImgModal(true) //Show Modal
  }

  const deleteBillImg = () => {
        let d_s = updateBillImageDelete(billImgToDelete)
        setBillImgToDelete("") //clear state
        setDeleteBillImgModal(false) //close modal when successfully deleted
  }

  const toggleEditDetailsModal = (details = false) => {
    setEditDetails(details);
    setEditPopupOpen(true);
  };

  const toggleAddDetailsModal = () => {
    setPopupOpen((prev) => !prev);
  };

  const selectAllEntries = () => {
    const selectableIds = filteredData.map((item) => item.id);  
    const allSelected = selectableIds.every((id) => selectedIds.includes(id));

      if (allSelected) {
        setSelectedIds([]);
      } else {
        setSelectedIds(selectableIds);
      }
  };


  const handlerImg = (imgName, mediaType) => {
    setZoom(imgName);
    setMediaDataType(mediaType);
  };

  const handlerZoomOut = () => {
    setZoom("");
    setMediaDataType("");
  };

  return (
    <>
      <SitePage>
        <TitleContainer>
          <div>
            <h2>Bills</h2>
            <p>Overview of operation's bills</p>
          </div>
          <div style={{gap: 10}}>
            <ExcelExport entriesData={filteredData} />
            {selectMode && (
              <Button variant="contained" onClick={selectAllEntries}>
                {!selectedIds.length ? "Select All" : "Deselect All"}
              </Button>
            )}
            <Button
              variant="outlined"
              color={selectMode ? "secondary" : "primary"}
              onClick={() => {
                setSelectMode((prev) => !prev);
                setSelectedIds([]); // reset
              }}
            >
              {selectMode ? "Exit Select Mode" : "Select Mode"}
            </Button>
            <Button variant="contained" onClick={toggleAddDetailsModal}>
              Add Bills
            </Button>
          </div>
        </TitleContainer>
        <BillFilters
          tableData={operation}
          setFilteredData={setFilteredData}
          setIsFiltered={setIsFiltered}
        />
        <BillTable
          filteredData={filteredData}
          handlerImg={handlerImg}
          toggleEditDetailsModal={toggleEditDetailsModal}
          handlerDetails={handlerDetails}
          handlerDeleteBillImg={handlerDeleteBillImg}
          selectMode={selectMode}
          selectedIds={selectedIds}
          setSelectedIds={setSelectedIds}
        />
      </SitePage>
      {selectMode && isPopupOpen && selectedIds.length > 0 && (
        <PopupForm
          item={selectedIds ? [...selectedIds] : [] }
          onUpload={handleUpload}
          onClose={() => setPopupOpen(false) && setSelectedIds([])  }
          isEditMode={false}
          data={null}
        />
      )}
      {editDetails?.id != undefined && isEditPopupOpen && (
        <PopupForm
          item={editDetails.id ? [editDetails.id] : [] }
          onUpload={handleUpload}
          onClose={() => setEditPopupOpen(false) && setEditDetails([])  }
          isEditMode={true}
          data={editDetails}
        />
      )}

      (
        <DeleteModal
        isOpen={openDeleteBillImgModal}
        title={"Images"}
        onClose={closeDeleteBillImgModal}
        onDelete={deleteBillImg}
        />
      )

      {modal === "open" ? (
        <Viewmore
          details={details}
          handlerDetails={handlerDetails}
          modal={modal}
        />
      ) : null}
      {modalType && <Modal />}
      {zoom && (
        <ZoomContainer>
          <Zoom>
            <ZoomHeader>
              <Icon onClick={handlerZoomOut}>
                <ClearIcon />
              </Icon>
            </ZoomHeader>

            <ZoomImg>
              <div style={{ display: "flex", overflowX: "auto", gap: "10px" }}>
                {zoom.map((url, idx) => (
                  <img
                    key={idx}
                    src={url}
                    alt={`bill-${idx}`}
                    style={{ width: "500px", height: "500px", objectFit: "contain" }}
                  />
                ))}
              </div>
            </ZoomImg>
          </Zoom>
        </ZoomContainer>
      )}
    </>
  );
};

const SitePage = styled.div`
  padding: 10px 10px;
  background-color: #fff;
  box-shadow: 0 0 5px 0 rgb(0 0 0 / 10%);
  overflow: hidden;
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
    0px 1px 1px rgba(0, 0, 0, 0.14), 0px 1px 3px rgba(0, 0, 0, 0.12);
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 20px;

  > div {
    &:last-child {
      display: flex;
      align-items: center;
    }
  }
`;

const ZoomContainer = styled.div`
  position: fixed;
  inset: 0;
  -webkit-backdrop-filter: blur(1px);
  backdrop-filter: blur(1px);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
`;

const Zoom = styled.div`
  background-color: #fff;
  width: 100%;
  max-width: 550px;
  position: fixed;
  padding: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
`;

const ZoomHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const ZoomImg = styled.div`
  width: 100%;
  height: 500px;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: inline-block;
  }
`;

const Icon = styled.div`
  cursor: pointer;
  padding: 5px;
`;

// export default Bills;
export default () => null;
